import type { Booking, BookingDeparture } from "@/types/camping";

export function hasBookingDraftInvoice(
  booking: Booking | BookingDeparture,
): booking is Booking & { draft_invoice_id: string } {
  return Boolean(booking.draft_invoice_id);
}

export function bookingDraftInvoiceAmount(booking: Booking | BookingDeparture): number {
  if (!booking.draft_invoice_amount) return 0;
  const amount = Number(booking.draft_invoice_amount);
  return Number.isFinite(amount) ? amount : 0;
}
